export default {
  label: "screen-readers",
  valueScope:[
    'sr-only',
    'sr-only-focusable',
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/screen-readers.js